import api from '../config/axiosConfig';

export const DocumentServices = {
    getDocuments: async (token) => {
        try {
            const response = await api.get('/ajustes/tipodocumentos',
                {
                    headers: { Authorization: `Bearer ${token}` },
                }
            );

            return response.data.tiposDocumentos;
        } catch (error) {
            console.error('Error en DocumentServices.getDocuments:', error);
            throw error;
        }
    },
};
